var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.569,
    height: 15.62,
    viewBox: "0 0 22.569 15.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M1167.727,660.584c0-.188-.049-.258-.249-.255-.932.013-1.863.012-2.8.016q-1.886.008-3.771.012c-.174,0-.248.048-.246.241q.021,1.853.02,3.707c0,.188.049.257.249.255,1.087-.015,2.175-.016,3.262-.021a.033.033,0,0,0,0,.009l3.24-.017c.161,0,.316.025.311-.24C1167.73,663.056,1167.727,661.819,1167.727,660.584Z",
    transform: "translate(-1152.908 -654.634)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M1147.088,656.928c.012,2.323.019,4.647.038,6.97a1.274,1.274,0,0,0,.339.929,1.7,1.7,0,0,0,1.256.477l-.05-9.822q-.116,0-.231.009A1.427,1.427,0,0,0,1147.088,656.928Z",
    transform: "translate(-1147.088 -652.557)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M1155.463,658.318q-.017-3.188-.032-6.377a1.385,1.385,0,0,0-1.142-1.4,5.607,5.607,0,0,0-.9-.042,1.456,1.456,0,0,0-1.38,1.109l.067,13.382a1.288,1.288,0,0,0,.64.817,2.312,2.312,0,0,0,1.441.209,1.432,1.432,0,0,0,1.351-1.534C1155.455,662.429,1155.474,660.373,1155.463,658.318Z",
    transform: "translate(-1149.197 -650.422)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M1179.016,651.666a1.3,1.3,0,0,0-.63-1.049,2.183,2.183,0,0,0-1.515-.215,1.548,1.548,0,0,0-.595.195,1.478,1.478,0,0,0-.72,1.375q.013,3.124.031,6.249t.031,6.228a1.356,1.356,0,0,0,1.187,1.4,4.555,4.555,0,0,0,1.2-.006,1.335,1.335,0,0,0,1.1-1.318c0-.438,0-.875-.007-1.313a.47.47,0,0,1,0-.047l-.05-10.137a.432.432,0,0,1-.008-.071C1179.041,652.527,1179.041,652.1,1179.016,651.666Z",
    transform: "translate(-1159.289 -650.363)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M1184.3,655.388a2.16,2.16,0,0,0-.473-.05l.049,9.808c.082,0,.165-.005.246-.011a1.346,1.346,0,0,0,1.279-1.329q-.018-3.517-.034-7.032A1.316,1.316,0,0,0,1184.3,655.388Z",
    transform: "translate(-1162.835 -652.495)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.1baf7e93958b0e51f0dc12d5b6a5e611.svg";
export { ForwardRef as ReactComponent };